import { render, staticRenderFns } from "./EditCompanyContact.vue?vue&type=template&id=44bf9b46"
import script from "./EditCompanyContact.vue?vue&type=script&lang=js"
export * from "./EditCompanyContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports